import JshModule from '@core/scripts/helper/jsh-module';
import Trinity from '@core/scripts/components/trinity-adapter.js';

const {moduleScope} = JshModule('footer/withdrawal-link');

moduleScope?.addEventListener('click', () => {
    Trinity.sendTrinityEvent({
        schema: {
            name: 'CLICK_FOOTER_BOTTOMLINKS',
            version: 6,
        },
        attributes: {
            clickName: 'withdrawContract',
            object: 'link',
        },
    });
});
